import React from "react";
import { TextLabel } from "../../components/style";
import moment from "moment";
import { USER_GROUP } from "src/constants/perks";
import { getEmailAudienceDisplayName } from "../../constants";

export default function TableAudienceName(props) {
    const { audience, setIsUpdatingContacts, setSelectedAudience } = props;

    const displayName = getEmailAudienceDisplayName(audience.name);
    return (
        <div>
            <div
                onClick={
                    audience.name === USER_GROUP.EMPLOYEES || audience.name === USER_GROUP.CLIENTS
                        ? () => { }
                        : () => {
                            setSelectedAudience(audience);
                            setIsUpdatingContacts(true);
                        }
                }
                style={{
                    cursor:
                        audience.name === USER_GROUP.EMPLOYEES ||
                            audience.name === USER_GROUP.CLIENTS
                            ? "default"
                            : "pointer",
                }}
            >
                <TextLabel
                    fontWeight="medium"
                    fontSize="15px"
                    color="#612684"
                    style={{
                        textDecoration:
                            audience.name === USER_GROUP.EMPLOYEES ||
                                audience.name === USER_GROUP.CLIENTS
                                ? ""
                                : "underline",
                        textTransform: "capitalize",
                    }}
                >
                    {displayName}
                </TextLabel>
            </div>
            <TextLabel marginBottom="0px" fontSize="13px">
                {`Created ${moment(audience.created_at).format("ddd, Do MMMM, YYYY, hh:mm A")}`}
            </TextLabel>
        </div>
    );
}
